<div class="container-fluid p-0">
    <div class="row">
        <div class="col-12">
            <div class="section-auth-container login-card">
                <div class="position-absolute bottom-0 end-0 bck-logo">
                    <img src="./../../../../assets/images/logo/logo_dark.png" alt="alfa force logo" height="200px">
                </div>
                <div>
                    <div class="login-main">
                        <form class="theme-form" ngNativeValidate [formGroup]="forgotPasswordForm">
                            <h4>Inserisci la tua email</h4>
                            <div class="form-group">
                                <label class="col-form-label">Email</label>
                                <div class="form-input position-relative">
                                    <input class="form-control" type="email" placeholder="email"
                                           formControlName="email">
                                    @if (forgotPasswordForm.controls['email'].touched &&
                                    forgotPasswordForm.controls['email'].errors?.['required']) {
                                        <div class="text text-danger mt-1"> {{'forms.error_mandatory_field' | translate}} </div>
                                    }
                                    @if (forgotPasswordForm.controls['email'].touched &&
                                    forgotPasswordForm.controls['email'].errors?.['email']) {
                                        <div class="text text-danger mt-1"> Email non valida </div>
                                    }
                                </div>
                            </div>
                            <div class="text-end mt-3 mb-3">
                                <button class="btn btn-primary btn-block w-100 sweet-2" type="submit"
                                        (click)="sendEmail()">Invia</button>
                            </div>
                            <p class="mt-4 mb-0">Sarà inviata una password temporanea al tuo indirizzo email.</p>
                            <a class="pull-right mt-5"  style="color:#fff" [routerLink]="['/auth/login']"> Torna al login</a>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
